import React from 'react';
import AuthStore from 'auth-store';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import BillerDashboardContainer from './BillerDashboardContainer';
import OrganizationDashboardContainer from './OrganizationDashboardContainer';

function DashboardRoutes() {
  const match = useRouteMatch();
  const userRole = AuthStore.get('_role');

  return (
    <Switch>
      {userRole === 'organization' && (
        <Route
          exact
          path={match.path}
          component={OrganizationDashboardContainer}
        />
      )}
      {userRole === 'biller' && (
        <Route exact path={match.path} component={BillerDashboardContainer} />
      )}
    </Switch>
  );
}

export default DashboardRoutes;
